import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/chuyen-muc/[slug]/PostsByShowcaseWall.js");
;
import(/* webpackMode: "eager" */ "/app/src/components/AccessInformation.js");
;
import(/* webpackMode: "eager" */ "/app/src/components/Activity2Columns.js");
;
import(/* webpackMode: "eager" */ "/app/src/components/ActivityBanner.js");
;
import(/* webpackMode: "eager" */ "/app/src/components/ActivityOther.js");
;
import(/* webpackMode: "eager" */ "/app/src/components/DraftDocument.js");
;
import(/* webpackMode: "eager" */ "/app/src/components/Event.js");
;
import(/* webpackMode: "eager" */ "/app/src/components/EventBanner.js");
;
import(/* webpackMode: "eager" */ "/app/src/components/FeaturedEvent.js");
;
import(/* webpackMode: "eager" */ "/app/src/components/Footer.js");
;
import(/* webpackMode: "eager" */ "/app/src/components/Header.js");
;
import(/* webpackMode: "eager" */ "/app/src/components/HeaderBanner.js");
;
import(/* webpackMode: "eager" */ "/app/src/components/HomeMedia.js");
;
import(/* webpackMode: "eager" */ "/app/src/components/LinkPage.js");
;
import(/* webpackMode: "eager" */ "/app/src/components/LocalPageProduct.js");
;
import(/* webpackMode: "eager" */ "/app/src/components/LocalProduct.js");
;
import(/* webpackMode: "eager" */ "/app/src/components/Menu.js");
;
import(/* webpackMode: "eager" */ "/app/src/components/NewText.js");
;
import(/* webpackMode: "eager" */ "/app/src/components/OtherBanner.js");
;
import(/* webpackMode: "eager" */ "/app/src/components/PostsByActivity.js");
;
import(/* webpackMode: "eager" */ "/app/src/components/PostsDetail.js");
;
import(/* webpackMode: "eager" */ "/app/src/components/PostsGeneral.js");
;
import(/* webpackMode: "eager" */ "/app/src/components/PostsMain.js");
;
import(/* webpackMode: "eager" */ "/app/src/components/PostsRelated.js");
;
import(/* webpackMode: "eager" */ "/app/src/components/PromoteTourism.js");
;
import(/* webpackMode: "eager" */ "/app/src/components/PromoteTourismPage.js");
;
import(/* webpackMode: "eager" */ "/app/src/components/RightBanner.js");
;
import(/* webpackMode: "eager" */ "/app/src/components/RunnerText.js");
;
import(/* webpackMode: "eager" */ "/app/src/page/ChiTietBaiVietPage/components/ChiTietBaiViet.js");
;
import(/* webpackMode: "eager" */ "/app/src/page/ChuyenMucPage/components/ChuyenMuc.js");
;
import(/* webpackMode: "eager" */ "/app/src/page/DonThuPage/components/BangDonThu.js");
;
import(/* webpackMode: "eager" */ "/app/src/page/DuThaoPage/components/BangDuThao.js");
;
import(/* webpackMode: "eager" */ "/app/src/page/HoiDapPage/components/HoiDap.js");
;
import(/* webpackMode: "eager" */ "/app/src/page/KienNghiCuTriPage/components/BangKienNghi.js");
;
import(/* webpackMode: "eager" */ "/app/src/page/LichPage/components/Lich.js");
;
import(/* webpackMode: "eager" */ "/app/src/page/LienHePage/components/Contact.js");
;
import(/* webpackMode: "eager" */ "/app/src/page/PdfPage/components/PdfView.js");
;
import(/* webpackMode: "eager" */ "/app/src/page/SoDoCongPage/components/SoDo.js");
;
import(/* webpackMode: "eager" */ "/app/src/page/TinTongHopPage/components/TinTongHop.js");
;
import(/* webpackMode: "eager" */ "/app/src/page/VanBanPage/components/BangVanBan.js");
